import { Component, Inject, OnInit, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PersonaDTO } from "app/main/apps/shared/interfaces/persona.interface";
import { Moment } from "moment";

@Component({
    selector: "app-dialog-asignar-contratista",
    templateUrl: "./dialog-asignar-contratista.component.html",
    styleUrls: ["./dialog-asignar-contratista.component.scss"],
})
export class DialogAsignarContratistaComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DialogAsignarContratistaComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            contratista: PersonaDTO;
            idOOTT: number;
            fcInicio: Moment;
            fcTermino: Moment;
        },
        private _fb: FormBuilder
    ) {}
    formAsignacion: FormGroup;
    ngOnInit(): void {
        //console.log(this.data);
        this.initForm();
    }

    initForm() {
        this.formAsignacion = this._fb.group({
            rango: this._fb.group({
                inicio: [null, { validators: [Validators.required] }],
                termino: [null, { validators: [Validators.required] }],
            }),
            // fechaInicio: [
            //     this.data.fcInicio,
            //     { validators: [Validators.required] },
            // ],
            // fechaTermino: [
            //     this.data.fcTermino,
            //     { validators: [Validators.required] },
            // ],
        });
        setTimeout(() => {
            this.inicio.setValue(this.data.fcInicio);
            this.termino.setValue(this.data.fcTermino);
        });
    }

    get rango() {
        return this.formAsignacion.get("rango");
    }

    get inicio() {
        return this.formAsignacion.get("rango").get("inicio");
    }

    get termino() {
        return this.formAsignacion.get("rango").get("termino");
    }

    // get fechaInicio() {
    //     return this.formAsignacion.get("fechaInicio");
    // }
    // get fechaTermino() {
    //     return this.formAsignacion.get("fechaTermino");
    // }
}
